import { ApolloClient, split, InMemoryCache, HttpLink } from "@apollo/client/core"
import { WebSocketLink } from "@apollo/client/link/ws"
import { getMainDefinition } from "@apollo/client/utilities"
import { onError } from "@apollo/client/link/error"
import { logErrorMessages } from "@vue/apollo-util"
import { useNotifications } from "@/store/notification"

const defaultOptions = {
    watchQuery: {
      fetchPolicy: 'no-cache',
      errorPolicy: 'ignore',
    },
    query: {
      fetchPolicy: 'no-cache',
      errorPolicy: 'all',
    },
  }

function getHttpUri() {
    let http_uri = import.meta.env["VITE_GRAPHQL_HTTP_ENDPOINT"]
    // console.log(http_uri)
    return http_uri 
}


function getWsUri() {
    let ws_uri = import.meta.env["VITE_GRAPHQL_WS_ENDPOINT"]
    // console.log("ws_uri",ws_uri)
    return ws_uri
}

function getHeaders() {
    const headers = {}
    const token = localStorage.getItem("refreshToken")

    if (token) {
        headers["Authorization"] = `Bearer ${token}`
    }
    return headers
}

// Create an http link:
const httpLink = new HttpLink({
    uri: getHttpUri(),
    fetch: (uri , options) => {
        options.headers = getHeaders()
        return fetch(uri, options)
    },
})

const errorLink = onError((error) => {
    const notifications = useNotifications()

    // console.dir(error)

    if(error?.response) {
        for(let errorMessage of error?.response?.errors) {
            notifications.newNotication("red",undefined,"Errore nel caricamento dei dati. \n Errore: "+errorMessage?.message ,"mdi-alert-circle")
        }
    }

    
    if (process.env.NODE_ENV !== "production") {
        logErrorMessages(error)
    }
})


 // Create a WebSocket link:

 const wsLink = new WebSocketLink({

  uri: getWsUri(),

  options: {

      reconnect: true,

      lazy: true,

      timeout: 30000,

      inactivityTimeout: 30000,

      connectionParams: () => {

          return { headers: getHeaders() }

      },

  },

})

// Create the apollo client
export const apolloClient = new ApolloClient({
    cache: new InMemoryCache({
        addTypename: false
    }),
    defaultOptions: defaultOptions,
    link: errorLink.concat(
      split(
          // split based on operation type
          ({ query }) => {
              const definition = getMainDefinition(query)
              return (
                  definition.kind === "OperationDefinition" &&
                  definition.operation === "subscription"
              )
          },
          wsLink,
          httpLink
      )
  ),
})